import { addLogoToPdf, addQRatAfterTable, registerNotoSansFont } from "helpers";
import { t } from "i18next";
import { jsPDF as JsPDF } from "jspdf";
import { toast } from "react-hot-toast";

import { ReturnDetails } from "../../returns.types";
import { getFonts } from "./getFonts";
import { renderDeliveryAndDriver } from "./renderDeliveryAndDriver";
import { renderHeader } from "./renderHeader";
import { renderPages } from "./renderPages";
import { renderPayment } from "./renderPayment";
import { renderProducts } from "./renderProducts";
import { renderTitles } from "./renderTitles";

const downloadReturnPdfAsync = async (
  returnsDetailsItems: ReturnDetails[]
): Promise<void> => {
  const pdf = new JsPDF({
    unit: "px"
  });

  // NotoSans supports French + every other non-Latin glyph we ship —
  // default helvetica renders garbled boxes for accents and emoji.
  await registerNotoSansFont(pdf);

  const { normalFontSize, normalFontStyles, bigFontSize, bigFontStyles } =
    getFonts();
  pdf.setLineHeightFactor(1.3);

  returnsDetailsItems.forEach((returnDetails, index) => {
    if (index > 0) {
      pdf.addPage();
    }

    addLogoToPdf(pdf);
    renderTitles({ pdf, normalFontSize, bigFontSize, returnDetails });
    renderHeader({ pdf, returnDetails, bigFontStyles });
    renderDeliveryAndDriver({
      pdf,
      returnDetails,
      bigFontStyles,
      normalFontStyles
    });
    renderProducts({ pdf, returnDetails, normalFontStyles });
    renderPayment({ pdf, returnDetails, normalFontStyles });
    addQRatAfterTable(pdf, `qr-${returnDetails.id}`, {
      width: 150,
      height: 150
    });
  });

  renderPages({ pdf });

  const fileName =
    returnsDetailsItems.length === 1
      ? `${t("Return")} ${returnsDetailsItems[0].id}`
      : `${t("Return")}`;

  pdf.save(`${fileName}.pdf`);
};

export const downloadReturnPdf = (
  returnsDetailsItems: ReturnDetails[]
): void => {
  downloadReturnPdfAsync(returnsDetailsItems).catch((err) => {
    console.error("Failed to generate return PDF:", err);
    toast.error(t("Failed to generate PDF"));
  });
};
